export const FILTER_KEY_TYPES = 'types'
export const FILTER_KEY_CALENDARS = 'calendars'
export const FILTER_KEY_START_DATE_RANGE = 'start_date_range'
export const FILTER_KEY_GEOGRAPHY_SLUGS = 'geography_slugs'
export const FILTER_KEY_EVENT_TYPES = 'event_types'
export const FILTER_KEY_INCLUDE_VIRTUAL = 'include_virtual_events'
export const FILTER_KEY_LABELS = 'labels'
export const FILTER_KEY_LOCATION = 'location'
export const FILTER_KEY_REGIONS = 'regions'
export const FILTER_KEY_BOUNDARY_BOX = 'boundary_box'
export const FILTER_KEY_UPCOMING_ONLY = 'upcoming_only'
export const FILTER_KEY_PARTNERSHIP = 'partnership'
